import { useCallback, useContext } from 'react';
import { UserContext } from '../contexts';
import { env } from '../config'
import { fetch } from '../utils/helpers';

const API_URL = `${env.REACT_APP_BILLING_API_URL}/Subscription`;

export const useSubscriptionApi = () => {
    
    const { getJwtToken } = useContext(UserContext);

    const getSubscriptions = useCallback(() => {
        return fetch(`${API_URL}/GetAllSubscriptions`, {
            method: 'GET',
        }, getJwtToken());
    }, [getJwtToken]);


    return {
        getSubscriptions
    };
};